<div class="p-4">
    <div class="demo-container">
        <div class="title">Web API Server Info</div>
        <div class="web-api-info">
            <div class="flex">
                <label>IP Address: </label>
                <pre class="d-inline">{{
				isLoadingIpAddress ? '...loading' : webApiIpAddress
			}}</pre>
            </div>
        </div>
    </div>
    <br />
    <div class="demo-container">
        <div class="title">Test Web API Responses</div>
            <div class="mt-4">
            <button
			    type="button"
			    class="btn btn-primary btn-sm"
			    (click)="triggerBadRequest()" data-testid="website-info-bad-request-400">
			    Bad Request (400)
		    </button>
		    <button
			    type="button"
			    class="btn btn-primary btn-sm"
			    (click)="triggerUnauthorized()" data-testid="website-info-unauthorized-401">
			    Unauthorized (401)
		    </button>
		    <button
			    type="button"
			    class="btn btn-primary btn-sm"
			    (click)="triggerForbidden()" data-testid="website-info-forbidden-403">
			    Forbidden (403)
		    </button>
		    <button
			    type="button"
			    class="btn btn-primary btn-sm"
			    (click)="triggerInternalServerError()" data-testid="website-info-internal-server-error-500">
			    Internal Server Error (500)
		    </button>
        </div>
	    <div class="mt-4">
		    <div class="d-flex align-items-center">
		    	<input
				    id="enable-console-log-info"
				    type="checkbox"
				    [(ngModel)]="consoleInfoLogsEnabled"
				    (change)="updateConsoleLogging()"
				    class="mx-1 my-1" data-testid="website-info-enable-info-console-logs-checkbox"/>
			    <label for="enable-console-log-info" class="mx-1 my-1"
				    >Enable Info Console Logs</label>
		    </div>

		    <div class="d-flex align-items-center">
			    <input
				    id="console-log-include-trace"
				    type="checkbox"
				    [(ngModel)]="consoleInfoLogsIncludeTrace"
				    (change)="updateConsoleLogging()"
				    class="mx-1 my-1" data-testid="website-info-include-stack-trace-in-checkbox"/>
			    <label for="console-log-include-trace" class="mx-1 my-1"
				    >Include Stack Trace In Console Log</label
			    >
		    </div>

		    <div class="d-flex align-items-center">
			    <input
				    id="show-access-token-expiration"
				    type="checkbox"
				    [(ngModel)]="showAccessTokenExpiration"
				    (change)="updateSessionCountdowns()"
				    class="mx-1 my-1" data-testid="website-info-show-access-token-expiration-checkbox"/>
			    <label for="show-access-token-expiration" class="mx-1 my-1">
				    Show Access Token Expiration
				    <small><i>*requires page refresh</i></small>
			    </label>
		    </div>

		    <div class="d-flex align-items-center">
			    <input
				    id="show-request-queue-test"
				    type="checkbox"
				    [(ngModel)]="showRequestQueueTestToggle"
				    (change)="updateShowRequestQueueTestToggle()"
				    class="mx-1 my-1" data-testid="website-info-show-request-queue-toggle-checkbox"/>
			    <label for="show-request-queue-test" class="mx-1 my-1">
				    Show Request Queue Toggle (not yet functional)
				    <small><i>*requires page refresh</i></small>
			    </label>
		    </div>
	    </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/developer/system-settings/website-info/website-info.component.html